<p-dialog modal="true" [(visible)]="showDialog" [closable]="false" [contentStyle]="{ 'max-height': '60vh' }"
  styleClass="atlas-dialog-m" [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
  <ng-template pTemplate="header">
    <h4>{{ 'profiles.new.title' | translate | titlecase }}</h4>
  </ng-template>
  <div [hidden]="hideDupeChecker">
    <wl-profile-dup-checker (onProfileSelected)="profileSelected($event)"></wl-profile-dup-checker>
  </div>
  <div [hidden]="hideProfileForm">
    <div class="mct-flex mct-row mct-gap-20">
      <div class="mct-flex-1-0-auto">
        <wl-profile-type-icon [isMember]="false" [isOrg]="profile.OrgInd"></wl-profile-type-icon>
        {{ 'profiles.new.new-profile' | translate | titlecase }}
      </div>
      <div class="flex row gap-20px">
        <div class="flex items-center">
          <p-radioButton name="orgIndRadio2" [value]="true" [(ngModel)]="profile.OrgInd" inputId="orgProfile"
            (ngModelChange)="onNameChanged()">
          </p-radioButton>
          <label class="mb-0 ml-2" for="orgProfile">{{ 'profiles.new.organization-profile' | translate | titlecase
            }}</label>
            
        </div>
        <div class="flex items-center">
          <p-radioButton name="orgIndRadio2" [value]="false" [(ngModel)]="profile.OrgInd" inputId="indProfile"
            (ngModelChange)="onNameChanged()">
          </p-radioButton>
          <label class="mb-0 ml-2" for="indProfile">{{ 'profiles.new.individual-profile' | translate | titlecase
            }}</label>
        </div>
      </div>
    </div>
    <hr />
    <div class="mct-flex mct-col mct-gap-20">
      <div class="mct-flex mct-row mct-gap-20">
        <div class="flex-1-1-50 column gap-20px" *ngIf="!profile.OrgInd">
          <div>
            <label>{{ 'common.personal-information.prefix' | translate | titlecase }}</label>
            <input data-cy="inputNewProfilePrefix" class="form-control" type="text" [(ngModel)]="profile.Prefix" />
          </div>
          <div>
            <label>{{ 'common.personal-information.first-name' | translate | titlecase }}</label>
            <input data-cy="inputNewProfileFirstName" class="form-control" type="text" [(ngModel)]="profile.FirstName"
              (changed)="onNameChanged()" wlTrimInput />
          </div>
          <div>
            <label>{{ 'common.personal-information.middle-initial' | translate | titlecase }}</label>
            <input data-cy="inputNewProfileMiddleInitial" class="form-control" type="text" [(ngModel)]="profile.Mi" />
          </div>
          <div>
            <label>{{ 'common.personal-information.last-name' | translate | titlecase }}</label>
            <input data-cy="inputNewProfileLastName" class="form-control" type="text" [(ngModel)]="profile.LastName"
              (change)="onNameChanged()" wlTrimInput />
          </div>
          <div>
            <label>{{ 'common.personal-information.suffix' | translate | titlecase }}</label>
            <input data-cy="inputNewProfileSuffix" class="form-control" type="text" [(ngModel)]="profile.Suffix" />
          </div>
          <div>
            <label>{{ 'common.personal-information.email' | translate | titlecase }}</label>
            <input data-cy="inputNewProfileEmail" class="form-control" type="text" [(ngModel)]="profile.Email" wlTrimInput />
          </div>
        </div>
        <div class="mct-flex-1-0-auto" *ngIf="profile.OrgInd">
          <div>
            <label>{{ 'common.personal-information.organization-name' | translate | titlecase }}</label>
            <input data-cy="inputNewProfileOrgName" class="form-control" type="text" [(ngModel)]="profile.OrgName" (change)="onOrgNameChanged()" wlTrimInput />
          </div>
          <div>
            <label>{{ 'profiles.sort-name' | translate | titlecase }}</label>
            <input class="form-control" type="text" [(ngModel)]="profile.ASF" wlTrimInput />
          </div>
        </div>
        <div class="mct-flex mct-col mct-flex-1-1-50pct" *ngIf="!hideProfileRelationForm">
          <wl-profile-edit-relationship></wl-profile-edit-relationship>
        </div>
      </div>
      <div class="mct-flex mct-row-reverse" [hidden]="!hideProfileRelationForm">
        <div class="mct-flex mct-row mct-gap-20">
          <div class="flex items-center">
            <p-radioButton name="memberProspectRadio" [value]="memberProspectOptions.NonMember"
              [(ngModel)]="memberProspect" inputId="nonMember">
            </p-radioButton>
            <label class="mb-0 ml-2" for="nonMember">Non-Member</label>
          </div>
          <div class="flex items-center">
            <p-radioButton name="memberProspectRadio" [value]="memberProspectOptions.Member"
              [(ngModel)]="memberProspect" [disabled]="disableAddMember" inputId="member">
            </p-radioButton>
            <label class="mb-0 ml-2" for="member">Member</label>
          </div>
          <div class="flex items-center">
            <p-radioButton name="memberProspectRadio" [value]="memberProspectOptions.Prospect"
              [(ngModel)]="memberProspect" [disabled]="disableAddProspect" inputId="prospect">
            </p-radioButton>
            <label class="mb-0 ml-2" for="prospect">Prospect</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [hidden]="!displayMemberActivityModal">
    <wl-profile-add-as-member [profile]="profile" embedMode="true"></wl-profile-add-as-member>
  </div>
  <div [hidden]="hideEditForm">
    <wl-profile-edit [profileId]="newProfileId" [relatedProfileId]="parentProfileId" hideSaveButtons="true"
      preventLoad="true"></wl-profile-edit>
  </div>
  <ng-template pTemplate="footer">
    <div class="alert alert-danger"
      [hidden]="addAsMemberMode || editMode || !profileDupChecker.profileResults.TotalCount">
      {{ 'profiles.new.this-profile-already-exists' | translate | titlecase }}
      <strong>
        <a (click)="toggleDupCheckVisible()">
          {{
          (profileDupChecker.showResults ? 'profiles.new.click-here-to-hide-matches' :
          'profiles.new.click-here-to-view-matches')
          | translate
          }}
        </a>
      </strong>
    </div>
    <div class="alert alert-danger" [hidden]="!errorMessage">
      {{ errorMessage }}
    </div>
    <wl-busy [show]="saving"></wl-busy>
    <button pButton type="button" data-cy="btnNewProfileIgnoreAndSave" class="atlas-btn atlas-btn-primary tall"
      icon="pi pi-save" [disabled]="saving" [hidden]="hideSaveAndIgnoreButton"
      [label]="'profiles.new.ignore-and-save' | translate | uppercase" (click)="saveAndIgnoreClick()"></button>
    <button pButton type="button" data-cy="btnNewProfileCancel" [label]="'common.cancel' | translate | titlecase"
      [disabled]="saving" (click)="newCancel()" class="atlas-btn atlas-btn-secondary-dark tall"
      icon="pi pi-ban"></button>

    <button pButton type="button" data-cy="btnNewProfileSave" class="atlas-btn atlas-btn-primary" *ngIf="editMode"
      [disabled]="saving" [icon]="saving ? '' : 'pi pi-save'"
      [label]="(saving ? 'common.saving' : 'common.save') | translate | titlecase"
      (click)="saveProfileEditClick()"></button>

    <button pButton type="button" data-cy="btnNewProfileContinue" class="atlas-btn atlas-btn-primary tall"
      *ngIf="addAsMemberMode" [disabled]="saving" [icon]="saving ? '' : 'pi pi-save'"
      [label]="(saving ? 'common.saving' : 'profiles.new.continue-editing') | translate | titlecase"
      (click)="saveAddAsMemberClick()"></button>

    <button pButton type="button" data-cy="btnNewProfileSaveClose" class="atlas-btn atlas-btn-primary tall"
      *ngIf="!editMode && !addAsMemberMode" [disabled]="saving" [icon]="saving ? '' : 'pi pi-save'"
      [label]="(saving ? 'common.saving' : 'common.save-and-close') | translate | titlecase"
      (click)="saveClickAndClose()"></button>

    <button pButton type="button" data-cy="btnNewProfileSaveContinue" class="atlas-btn atlas-btn-primary tall"
      *ngIf="!editMode && !addAsMemberMode" [disabled]="saving || profileDupChecker.profileResults.TotalCount"
      [icon]="saving ? '' : 'pi pi-save'"
      [label]="(saving ? 'common.saving' : 'profiles.new.continue-editing') | translate | titlecase"
      (click)="saveClick()"></button>
  </ng-template>
</p-dialog>